import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-late-modal',
  templateUrl: './late-modal.component.html'
})
export class LateModalComponent implements OnInit {
  @Input() unattended: number;
  @Input() attending: number;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  modalTimer: any = localStorage.getItem('modalTimer');
  interval: any;

  ngOnInit() {
    this.modalTimer = this.modalTimer == null ? 300000 : this.modalTimer;
    this.interval = setInterval(()=> { this.activeModal.close(false); clearInterval(this.interval) }, this.modalTimer)
  }
}
